import { ContentProps } from '@components/CreditCardContent/components/Content.interface'

const noMinimumGuaranteedCreditLimitContent = ({
    creditCard,
}: {
    creditCard: ContentProps['creditCard']
}) => {
    return creditCard.guaranteedRate?.guaranteedOfferType ===
        'ApplyForGuaranteedLimit' ||
        creditCard.guaranteedRate?.guaranteedCreditLimit == null
        ? {
              title: undefined,
              value: undefined,
              detailType: 'application',
          }
        : null
}

export default noMinimumGuaranteedCreditLimitContent
